module.exports = __webpack_public_path__ + "img/title2.577592eb.png";